import { HTTP_CP_SmartSearchCase } from '@api-new/caseservice';
import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { smartSearchCasesAdapter } from '@shared/store/smart-search-cases/smart-search-cases.reducer';
import { SmartSearchCasesState } from '@shared/store/smart-search-cases/smart-search-cases.state';

const { selectAll, selectEntities } = smartSearchCasesAdapter.getSelectors();

export const selectSmartSearchCasesState = createFeatureSelector<SmartSearchCasesState>('smartSearchCases');

export const selectSmartSearchCases = createSelector(selectSmartSearchCasesState, (smartSearchCasesState: SmartSearchCasesState) =>
  selectAll(smartSearchCasesState),
);

export const selectSmartSearchCaseEntities = createSelector(selectSmartSearchCasesState, (smartSearchCasesState: SmartSearchCasesState) =>
  selectEntities(smartSearchCasesState),
);

export const selectSmartSearchCase = (smartSearchCaseId: string) =>
  createSelector(
    selectSmartSearchCaseEntities,
    (smartSearchCaseEntities: Dictionary<HTTP_CP_SmartSearchCase>) => smartSearchCaseEntities[smartSearchCaseId] ?? null,
  );

export const selectSmartSearchCaseBySmartSearchId = (smartSearchId: string) =>
  createSelector(selectSmartSearchCases, (smartSearchCases: HTTP_CP_SmartSearchCase[]) =>
    smartSearchCases.find((smartSearchCase) => smartSearchCase.smartSearchId === smartSearchId),
  );

export const selectIsLoadingSmartSearchCases = createSelector(
  selectSmartSearchCasesState,
  (smartSearchCasesState: SmartSearchCasesState) => smartSearchCasesState.loading,
);
